import React, { Component } from 'react'

import PermissionsChecker from '@shared/PermissionsChecker'
import Receipt from '@components/Receipt'
import RolesChecker from '@shared/RolesChecker'
import ConfirmDialog from '@shared/ConfirmDialog'
import TrackingTimeline from '../TrackingTimeline'
import Alert from '../../shared/Alert'
import { getSubOrderNf } from '@services/sm-api'

class CardSubOrder extends Component {
  state = {
    opened: false,
    alertNF: false,
    loadingNF: false
  }

  _printHandler() {
    let { sub_order, buyer_name, status, openModal, closeModal } = this.props

    openModal(
      <Receipt
        sub_order={sub_order}
        buyer_name={buyer_name}
        closeModal={closeModal}
        status={status}
        title="Comprovante de retirada"
      />,
    )
  }

  // _confirmCancel() {
  //   let { sub_order, buyer_name, status, openModal, closeModal, cancelSubOrder } = this.props

  //   openModal(
  //     <ConfirmDialog
  //       text="Tem certeza que deseja cancelar esse pedido?"
  //       ok={() => {
  //         cancelSubOrder(sub_order.id)
  //         closeModal()
  //       }}
  //       cancel={() => closeModal()}
  //     />,
  //   )
  // }



  _isServiceLine(sub_order) {
    const exp = /SER/gm
    if (sub_order.business_line.match(exp)) {
      return true
    }
    return false
  }

  _formatOldTrackingLink(tracking_link) {

    if (!tracking_link) return null

    let loggiLink = tracking_link
    loggiLink = loggiLink.replace("https://www.loggi.com/rastreador/", "");
    let params = loggiLink.split('/')
    if (params.length === 2) {
      return 'https://www.loggi.com/rastreador/' + params[1]
    } {
      return tracking_link
    }
  }

  _isDigitalLine(sub_order) {
    const exp = /DIG/gm
    if (sub_order.business_line.match(exp)) {
      return true
    }
    return false
  }

  _getOrderDeliveryDestination() {
    const { order, sub_order } = this.props
    if (sub_order.school_is_b2c) {
      let address = ''
      let address_ = ''
      if (order.buyer_address_zipcode_delivery) {
        address = `${order.buyer_address_street_delivery}, ${order.buyer_address_number_delivery}${order.buyer_secondary_address_number_delivery ? ', ' + order.buyer_secondary_address_number_delivery : ''
          } - ${order.buyer_address_neighborhood_delivery}`
        address_ = `${order.buyer_address_city_delivery} - ${order.buyer_address_state_delivery}, ${order.buyer_address_zipcode_delivery}`
      } else {
        address = `${order.buyer_address_street}, ${order.buyer_address_number}${order.buyer_secondary_address_number ? ', ' + order.buyer_secondary_address_number : ''
          } - ${order.buyer_address_neighborhood}`
        address_ = `${order.buyer_address_city} - ${order.buyer_address_state}, ${order.buyer_address_zipcode}`
      }
      return (
        <React.Fragment>
          {address}
          <br />
          {address_}
        </React.Fragment>
      )
    }
    return 'Os livros serão entregues na escola'
  }

  renderInvoice(invoiceWindow, danfe) {
    // reseta o conteúdo (remove o "Consultando…") antes de injetar o PDF —
    // sem o document.open(), o write apenas ANEXA e o texto de loading fica na tela.
    invoiceWindow.document.open();
    invoiceWindow.document.write(
      `
      <style>body { margin: 0 } embed { margin: auto; width: 100dvw; height: 100dvh; } </style>
      <embed src='data:application/pdf;base64,${encodeURI(danfe)}'>
      `
    );
    invoiceWindow.document.close();
  }

  // Consulta o SAP em tempo real a cada clique (sem depender da rotina cron).
  // Se a NF estiver disponível, abre o PDF; senão, exibe a mensagem de "processando".
  async _handleDownloadNf() {
    if (this.state.loadingNF) return
    this.setState({ alertNF: false, loadingNF: true })
    // Abre a janela AGORA, dentro do gesto do usuário — se abrir só após o await, o
    // navegador (Safari/Firefox/Chrome com bloqueador) bloqueia o pop-up e a NF nunca aparece.
    const invoiceWindow = window.open('', '_blank', `width=${window.screen.availWidth * 0.50},height=${window.screen.availHeight * 0.70}`)
    if (invoiceWindow) {
      invoiceWindow.document.write('<p style="font-family: sans-serif; padding: 16px">Consultando nota fiscal…</p>')
    }
    try {
      const data = await getSubOrderNf(this.props.sub_order.id)
      if (data && data.danfe && invoiceWindow) {
        this.renderInvoice(invoiceWindow, data.danfe)
      } else {
        if (invoiceWindow) invoiceWindow.close()
        this.setState({ alertNF: true })
      }
    } catch (e) {
      if (invoiceWindow) invoiceWindow.close()
      this.setState({ alertNF: true })
    } finally {
      this.setState({ loadingNF: false })
    }
  }

  render() {
    const { sub_order, status, children, cancelSubOrder, order } = this.props
    const hasCancelledItem = sub_order.products.some(product => product.cancelled_at !== null)
    let show = this.state.opened ? 'less' : 'more'

    return (
      <>
        <div className='card-suborder'>
          <div className='card-suborder__header'>
            <h3 className='suborder-title'>Pedido: {sub_order.sub_order_code}</h3>
            <div className='card-suborder__actions'>
              {
                // Botão só aparece quando ainda não cancelado
                status.code !== 'C' && status.code !== 'CBS' && status.code !== 'CES' && (
                  <PermissionsChecker permissions={['cancel_order']}>
                    <div className="card-student-detail__sub_order_cancel">
                      <a href="#" onClick={e => e.preventDefault() & cancelSubOrder(sub_order.id)}>Cancelar pedido</a>
                    </div>
                  </PermissionsChecker>
                )
              }
              {status.code === 'AP' || status.code === 'PG' || status.code === 'PAV' ? (
                <span className="card-student-detail__column-printer-text" onClick={() => this._printHandler()}>Comprovante</span>
              ) : null}
{order.campaign_id > 11 ? (
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <span
                  style={{
                    backgroundColor: '#dbdbdb',
                    borderRadius: '5px',
                    cursor: this.state.loadingNF ? 'wait' : 'pointer',
                    fontSize: '14px',
                    padding: '7px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    justifyItems: 'center',
                    alignItems: 'center',
                    gap: '5px',
                    opacity: this.state.loadingNF ? 0.6 : 1
                  }}
                  onClick={() => this._handleDownloadNf()}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="15" height="15">
                    <path fill="#575252" d="M18,0H6A3,3,0,0,0,3,3V23.9l3.67-2.51,2.671,1.826,2.666-1.826,2.666,1.826,2.664-1.825L21,23.9V3A3,3,0,0,0,18,0ZM15,14H7V12h8Zm2-5H7V7H17Z" />
                  </svg>
                  {this.state.loadingNF ? 'Consultando…' : 'Baixar NF'}
                </span>
              </div>
) : (
              ''
)}
            </div>
          </div>



          {this.state.alertNF && (

            <div className='card-suborder__header' style={{ justifyContent: 'flex-end' }}>
              <div className='alert-card-student-orders' style={{ width: '50%', fontSize: '12px', backgroundColor: 'rgb(236 98 98)', color: 'white', borderRadius: '10px', border: 'none' }}>
                <span className="fa fa-warning"></span> &nbsp;&nbsp;
                Sua nota fiscal está sendo processada, pedimos que aguarde e logo será disponibilizada.
              </div>
            </div>
          )}


          <div className='card-suborder__body'>
            <div className='card-suborder-info'>
              <p><strong>Tipo de produto: </strong> {sub_order.business_line_name}</p>
              <p><strong>Aluno: </strong> {sub_order.student_name}</p>
              {this._isServiceLine(sub_order) ?
                <p><strong>Entrega: </strong> Após confirmação de pagamento, a licença será enviada para o e-mail que realizou a compra.</p>
                : this._isServiceLine(sub_order) ? '' :
                  <p><strong>Entrega: </strong> {this._getOrderDeliveryDestination()}</p>}
            </div>

            {hasCancelledItem && (
              <Alert title="Item cancelado neste pedido!">
                Um dos itens deste pedido foi cancelado. O valor total já foi atualizado e, se aplicável, o reembolso será processado.
              </Alert>
            )}

          </div>
          <TrackingTimeline subOrder={sub_order} order={order} />

          {
            sub_order.business_line_id === 7 || !sub_order.school_is_b2c ? '' : <div className='card-suborder__footer' style={{ borderTop: !sub_order.history.some(history => history.status === 'PF') && 'none' }}>
              <div className='tracking-info'>
                {sub_order.history.some(history => history.status === 'PF') ? <p className='tracking-code'><strong>Nota de entrega: {sub_order?.nf_number || '##########'} </strong></p> : ''}
                {sub_order.history.some(history => history.status === 'PT') ? <p><a target='_blank' href={this._formatOldTrackingLink(sub_order.tracking_link) || '#'}>Clique aqui para acompanhar a entrega</a></p> : ''}
              </div>
            </div>
          }

          <div className={`card-student-detail__switch-book-view ${show}`}>
            <button onClick={() => this.setState({ opened: !this.state.opened })}>
              <span className="label">{this.state.opened ? 'Ocultar detalhes' : 'Ver detalhes'}</span>
            </button>
          </div>
          {this.state.opened ? children : null}
        </div>
      </>
    )
  }
}

export default CardSubOrder
